import { ArcadeWheelProperties } from "@lib/titan2-slingo/dist/game/view/abstract/display/ArcadeWheel";
/**
 * ArcadeWheelLandscapeProperties.ts
 */
export class ArcadeWheelLandscapeProperties extends ArcadeWheelProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.scaleNotInProgress.set(0.47);
        this.scaleInProgress.set(0.8);
        this.scaleHidden.set(0.47);
        this.offsetNotInProgress.set(138, 122);
        this.offsetInProgress.set(75, 145);
        this.offsetHidden.set(773, 145);
        this.instructionsProperties.position.set(963, 175); //our grid is 10 pixels offset
        this.instructionsProperties.size.set(690, 600);
        this.instructionsBackgroundProperties.scale.set(1);
    }
}
//# sourceMappingURL=ArcadeWheelLandscapeProperties.js.map